// The deal's history in words (AC9, TX-US-0043): what each event is called, what its detail
// says, and the approval rounds read from it. One set of words, so the timeline and the rounds
// name a decision the same way. Each kind of event carries its own detail shape
// (trex/deals/flow_service.py, trex/documents/service.py).

import { typeLabel } from '../documents/documentTypes.js';
import { stateLabel } from './dealForm.js';
import { STAGE_LABELS } from './flow.js';

const ROUND_EVENTS = {
  SUBMITTED: 'Submitted',
  WITHDRAWN: 'Withdrawn',
  COMMERCIAL_APPROVED: 'Commercial step approved',
  COMMERCIAL_RETURNED: 'Commercial step returned',
  COMMERCIAL_REJECTED: 'Commercial step rejected',
  RISK_APPROVED: 'Risk step approved',
  RISK_RETURNED: 'Risk step returned',
  RISK_REJECTED: 'Risk step rejected',
};

export const EVENT_LABELS = {
  CREATED: 'Deal opened',
  FIELDS_UPDATED: 'Edited',
  STATUS_CHANGED: 'Status changed',
  STATE_CHANGED: 'State changed',
  STAGE_CHANGED: 'Moved',
  REOPENED: 'Reopened',
  CANCELLED: 'Cancelled',
  ...ROUND_EVENTS,
  DOCUMENT_ATTACHED: 'Document attached',
  DOCUMENT_REMOVED: 'Document removed',
  DOCUMENT_RETYPED: 'Document type changed',
  DELETED: 'Deal deleted',
};

export const eventLabel = (event) => EVENT_LABELS[event.event_type] ?? event.event_type;

const stageLabel = (stage) => STAGE_LABELS[stage] ?? stage;

// The words beside an entry, from its detail, or null when it has none to show.
export function describe(event) {
  const detail = event.detail ?? {};
  const reason = detail.reason ? `: ${detail.reason}` : '';
  switch (event.event_type) {
    case 'STAGE_CHANGED':
      return `${stageLabel(detail.from)} → ${stageLabel(detail.to)}${reason}`;
    case 'DOCUMENT_RETYPED':
      return `${detail.filename}: ${typeLabel(detail.from)} → ${typeLabel(detail.to)}`;
    case 'REOPENED':
    case 'CANCELLED':
      return detail.reason ?? null;
    default:
      break;
  }
  if (detail.round) return `round ${detail.round}${reason}`;
  if (detail.changed) return `changed: ${detail.changed.join(', ')}`;
  if (detail.from) return `${stateLabel(detail.from)} → ${stateLabel(detail.to)}`;
  if (detail.filename) return detail.filename;
  return null;
}

// Each round's submission, decisions and withdrawal, oldest first (AC13).
export const roundsOf = (events = []) => events
  .filter((event) => event.event_type in ROUND_EVENTS && event.detail?.round)
  .map((event) => ({
    round: event.detail.round,
    what: ROUND_EVENTS[event.event_type],
    by: event.actor_display_name || event.actor_user_id,
    at: event.occurred_at,
    reason: event.detail.reason ?? null,
  }));
